import { TextField } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'

import FileUpload from 'app/components/generic/FileUpload'

import { Card, FieldRow, FileName, SectionLabel } from './styles'

const CsvUploadPanel = (props) => {
  const { file, onFileChange } = props

  const handleUpload = (e) => {
    const selected = e.target.files && e.target.files[0]
    if (selected) {
      onFileChange(selected)
    }
  }

  const handleClear = () => onFileChange(null)

  return (
    <Card>
      <SectionLabel>csv file</SectionLabel>
      <FieldRow $cols={1}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <FileUpload
            label={file ? 'replace csv' : 'choose csv'}
            onUpload={handleUpload}
            inputProps={{ accept: '.csv,text/csv' }}
          />
          {file ? (
            <>
              <FileName>{file.name}</FileName>
              <TextField onClick={handleClear} style={{ display: 'none' }} />
              <button
                type="button"
                onClick={handleClear}
                style={{
                  border: 0,
                  background: 'transparent',
                  cursor: 'pointer',
                  color: '#c43d3d',
                  fontFamily: 'AvenirDemi',
                  fontSize: 12,
                  textTransform: 'lowercase'
                }}
              >
                remove
              </button>
            </>
          ) : (
            <FileName>no file selected</FileName>
          )}
        </div>
      </FieldRow>
    </Card>
  )
}

CsvUploadPanel.propTypes = {
  file: PropTypes.object,
  onFileChange: PropTypes.func.isRequired
}

export default CsvUploadPanel
